module.exports = __webpack_public_path__ + "static/media/Used Cat Paving Products - Toromont Cat.4233bbf6.jpg";